import { render, staticRenderFns } from "./AppArgentinaPontos.vue?vue&type=template&id=1207ee42&scoped=true&lang=pug"
import script from "./AppArgentinaPontos.vue?vue&type=script&lang=js"
export * from "./AppArgentinaPontos.vue?vue&type=script&lang=js"
import style0 from "./AppArgentinaPontos.vue?vue&type=style&index=0&id=1207ee42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1207ee42",
  null
  
)

export default component.exports